




"use strict";

const addClass = className => elem => elem.classList.add(className);
const removeClass = className => elem => elem.classList.remove(className);


// Returns object with all fields and a true/false value if filled
const getFilledFieldsObj = (fields,input) => {
    if ( input.parentElement.offsetParent !== null ) {
        if ( !fields[input.name] ) {
            fields[input.name] = false;
        }

        if ( input.type === 'radio' && input.checked ) {
            fields[input.name] = true;
        }

        if ( input.nodeName === 'SELECT' && input.value ) {
            fields[input.name] = true;
        }

        if ( ['text', 'email', 'phone', 'file'].indexOf(input.type) !== -1 && input.value !== '' ) {
            fields[input.name] = true;
        }

    }

    return fields;
};


// Return true/false if thermometer field is active
const isToggleFieldActive = (bActive, input) => {
    if ( input.dataset.toggle && input.checked ) {
        bActive = true;
    }
    return bActive;
}


// Fill result section
const fillResults = values => (section,index) => {
    if ( values[index] ) {
        section.innerHTML = '';
        addClass('visible')(section);
        values[index].forEach(item => {
            section.innerHTML += `<dt>${item.name}</dt>`;
            section.innerHTML += `<dd>${item.value}</dd>`;
        });
    } else {
        removeClass('visible')(section);
    }
};


// Check if field is empty
const filterEmptyFields = field => {
    if ( field.type === 'text' && field.value !== '' ) {
        return true;
    }
    else if ( field.type === 'radio' && field.checked ) {
        return true;
    }
};





export default class CheckoutForm {
    constructor (elem) {
        if ( !elem) {
            return;
        }
        this.form = elem;

        // Custom events
        this.inputChangeEvent = new CustomEvent('inputChange');
        this.beforeSectionChangeEvent = new CustomEvent('beforeSectionChange');
        this.sectionChangeEvent = new CustomEvent('sectionChange');

        // Event listeners
        this.form.addEventListener('inputChange', () => this.setThermometerVisibility());
        this.form.addEventListener('inputChange', () => this.setFileUploadVisibility());
        //this.form.addEventListener('inputChange', () => this.validateForm());
        this.form.addEventListener('inputChange', () => this.setNextButtonActive());
        //this.form.addEventListener('inputChange', () => this.changeStepButtons());

        this.form.addEventListener('beforeSectionChange', () => this.saveValues());

        this.form.addEventListener('sectionChange', () => this.showResults());
        this.form.addEventListener('sectionChange', () => this.setSectionVisibility());
        this.form.addEventListener('sectionChange', () => this.setTitleComplete());
        this.form.addEventListener('sectionChange', () => this.setNextButtonActive());
        //this.form.addEventListener('sectionChange', () => this.changeStepButtons());
        this.form.addEventListener('sectionChange', () => this.fillSidebar());
        this.form.addEventListener('sectionChange', () => console.log('section change'));

        // Initialize form events
        this.addEvents();

        // Default values
        this.values = {};
        this._currentSectionIndex = 0;

        // Trigger input change on load
        this.form.dispatchEvent(this.inputChangeEvent);

        // Skip sections that are completed
        this.gotoNextSectionIfComplete();
    }



    // Dispatch change event on section index change
    get currentSectionIndex () {
        return this._currentSectionIndex;
    }
    set currentSectionIndex (newVal) {
        this.form.dispatchEvent(this.beforeSectionChangeEvent);
        this._currentSectionIndex = newVal;
        this.form.dispatchEvent(this.sectionChangeEvent);
    }

    // Current section element
    get currentSection () {
        return this.form.querySelectorAll('.form-section')[this.currentSectionIndex];
    }


    // Check input fields if thermometers should be visible
    get thermometerVisible () {
        return this.thermometerFields
            .reduce(isToggleFieldActive, false)
    }

    // Thermometer fields
    get thermometerFields () {
        return Array.from(this.form.querySelectorAll('.thermometer_radio'));
    }

    // Check input fields if file upload should be visible
    get uploadFieldsVisible () {
        return this.uploadFields
            .reduce(isToggleFieldActive, false)
    }

    // File upload fields
    get uploadFields () {
        return Array.from(this.form.querySelectorAll('.file_radio'));
    }


    // Input field in the current section
    get currentSectionFields () {
        if ( !this.currentSection ) {
            return [];
        }
        return Array.from(this.currentSection
                    .querySelectorAll('input, select'))
    }

    // Get values of the completed section
    get currentSectionValues () {
        return this.currentSectionFields
            .filter(elem => elem.parentElement.offsetParent !== null)
            .filter(filterEmptyFields)
            .map(field => {
                return {
                    name: field.dataset.name || field.name,
                    value: field.dataset.value || field.value,
                }
            });
    }

    // Check if the required fields in the section are filled
    get requiredFieldsFilled () {
        const oFields = this.currentSectionFields
            .reduce(getFilledFieldsObj, {});

        return Object.values(oFields).every(filled => filled);
    }

    // Return all form titles
    get formTitles () {
        return this.form.querySelectorAll('.form-section-title');
    }



    // Save form values
    saveValues () {
        this.values[this.currentSectionIndex] = this.currentSectionValues;
    }


    // Show results sections
    showResults () {
        this.form.querySelectorAll('.result-section')
            .forEach(fillResults(this.values));
    }


    // Add items to sidebar
    fillSidebar () {
        const eSelection = this.form.querySelector('.selection');
        Object.values(this.values)
            .forEach(sectionFields => {
                sectionFields
                    .filter(field => ['Installatie', 'Thermostaat'].indexOf(field.name) !== -1 )
                    .forEach(field => {
                        const eItem = eSelection.querySelector('.'+field.name)
                                      || document.createElement('li');
                        eItem.classList.add(field.name);
                        eItem.innerHTML = field.value;
                            
                        eSelection.append(eItem);
                    });
        });
    }

    // Validate single field
    validateField (input) {
        if ( !input.required ) {
            return true;
        } else if (input.required && input.value !== '') {
            return true;
        }

        return false;
    }

    // Post form if complete
    async postForm () {
        const formData = new FormData(this.form);
        const sFormUrl = `${ylt.ajax_url}?action=offerte_form`;

        formData.append('save', true);

        fetch(sFormUrl, {
            method: 'POST',
            body: formData
        });
    }

    // Check address from postcode API
    async checkAddress () {
        const sPostcode = this.form.querySelector('input[name="Postcode"]').value;
        const sHuisnummer = this.form.querySelector('input[name="Huisnummer"]').value;

        const sPostcodeUrl = `${ylt.ajax_url}?action=check_postcode&postcode=${sPostcode}&huisnummer=${sHuisnummer}`;

        const oAddress = await fetch(sPostcodeUrl).then(response => response.json());

        if ( oAddress ) {
            const sAddress = oAddress.street +', '+ oAddress.number;
            const addressField = this.form.querySelector('.show-address');
            addressField.querySelector('.address').innerHTML = sAddress;
            addressField.classList.add('active');
        }
    }


    // Update thermometer class
    setThermometerVisibility () {
        const thermoOptions = this.form.querySelector('.thermo-options');

        if ( thermoOptions ) {
            if ( this.thermometerVisible ) {
                addClass('visible')(thermoOptions);
            } else {
                removeClass('visible')(thermoOptions);
            }
        }
    }


    // Update file upload class
    setFileUploadVisibility () {
        const fileUpload = this.form.querySelector('.file-upload');

        if ( fileUpload ) {
            if ( this.uploadFieldsVisible ) {
                addClass('visible')(fileUpload);
            } else {
                removeClass('visible')(fileUpload);
            }
        }
    }


    // Enable or disable next button
    setNextButtonActive () {
        const nextBtn = ( this.currentSection )
                        ? this.currentSection.querySelector('.next')
                        : undefined;

        if ( nextBtn ) {
            if ( this.requiredFieldsFilled ) {
                nextBtn.disabled = false;
            } else {
                nextBtn.disabled = true;
            }
        }
    }


    // Setup step buttons in form header
    changeStepButtons (prevBtn, nextBtn) {
        const steps = document.querySelector('.gf_page_steps');

        let prev = steps.querySelector('.prev-btn');
        let next = steps.querySelector('.next-btn');

        if ( !prev && !next ) {
            prev = document.createElement('button');
            prev.classList.add('prev-btn');
            prev.setAttribute('aria-hidden', true);

            next = document.createElement('button');
            next.classList.add('next-btn');
            next.setAttribute('aria-hidden', true);

            steps.prepend(prev);
            steps.append(next);
        }

        prev.addEventListener('click', evt => {
            evt.preventDefault();

            if ( prevBtn ) {
                prevBtn.click();
            }
        });

        next.addEventListener('click', evt => {
            evt.preventDefault();

            if ( nextBtn ) {
                nextBtn.click();
            }
        });

        if ( nextBtn && nextBtn.disabled ) {
            prev.setAttribute('aria-hidden', true);
            next.setAttribute('aria-hidden', true);
        } else {
            prev.removeAttribute('aria-hidden');
            next.removeAttribute('aria-hidden');

            if ( steps.querySelector('.gf_step_active.gf_step_first') ) {
                prev.setAttribute('aria-hidden', true);
            }

            if ( steps.querySelector('.gf_step_active.gf_step_last') ) {
                next.setAttribute('aria-hidden', true);
            }
        }
    }


    // Skip section if it's complete
    gotoNextSectionIfComplete () {
        while ( this.requiredFieldsFilled && this.currentSection ) {
            this.currentSectionIndex++;
        }
    }


    // Set current section visibility
    setSectionVisibility () {
        // Disable all sections
        this.formTitles
            .forEach(removeClass('active'));

        if ( this.currentSection ) {
            // Enable current section
            this.currentSection.previousSibling.classList.add('active');

            // Disable results
            removeClass('visible')(this.currentSection.nextElementSibling);
        }
    }


    // Add class to the titles of completed sections
    setTitleComplete () {
        this.formTitles
            .forEach((title, index) => {
                if ( this.values[index] && this.values[index].length > 0 ) {
                    addClass('complete')(title);
                } else {
                    removeClass('complete')(title);
                }
            });
    }


    // Add all form events
    addEvents () {
        this.form.querySelectorAll('.form-section').forEach(section => {
            // Fire input change event
            section.querySelectorAll('input, select').forEach(input => {
                if ( input.type === 'radio' || input.nodeName === 'SELECT' ) {

                    // Change event
                    input.addEventListener('change', () => {
                        this.form.dispatchEvent(this.inputChangeEvent);
                    });

                } else if (['text', 'email', 'phone', 'file'].indexOf(input.type) !== -1 ) {

                    // Keyup event
                    input.addEventListener('keyup', () => {
                        this.form.dispatchEvent(this.inputChangeEvent);

                        if ( input.name === 'Postcode' || input.name === 'Huisnummer' ) {
                            this.checkAddress();
                        }
                    });

                    input.addEventListener('change', () => {
                        if ( this.validateField(input) ) {
                            input.parentElement.classList.add('validated');
                        } else {
                            input.parentElement.classList.remove('validated');
                        }

                        //this.changeStepButtons();
                    });
                }


            });

            // Goto next section
            section.querySelectorAll('.next:not(.submit)').forEach(button => {
                button.addEventListener('click', () => {
                    if ( this.requiredFieldsFilled ) {
                        this.currentSectionIndex++;
                    }
                });
            });

            const submit = section.querySelector('.submit');
            if ( submit ) {
                submit.addEventListener('click', () => {
                    this.postForm();
                });
            }
        });


        // Edit button click
        this.formTitles.forEach((title, index) => {
            title.querySelector('.edit').addEventListener('click', () => {
                this.currentSectionIndex = index;
            });
        });



        const prevButton = this.form.querySelector('.gform_page:not([style]) .gform_previous_button');
        const nextButton = this.form.querySelector('.gform_page:not([style]) .gform_next_button');
        this.changeStepButtons(prevButton, nextButton);

        const observerOptions = {
            attributes: true,
        };


        const observeDisabled = (mutations) => {
            mutations
                .forEach(mutation => {
                    if ( mutation.type === 'attributes' && mutation.attributeName === 'disabled' ) {
                        this.changeStepButtons(prevButton, mutation.target)
                    }
                })
        }

        const observer = new MutationObserver(observeDisabled);
        if ( nextButton ) {
            observer.observe(nextButton, observerOptions);
        }
    }
}
